import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { systemActions } from '@/store/features/system.slice';
import { useTranslation } from 'react-i18next';
import { TimerCloseButton } from '@/components';
import { ErrorType } from '@/types/error.type';

export default function Error({
  status,
  name,
  message,
  stack,
  method,
  path,
  timestamp,
  removable = false,
  expended = false,
  validations,
  ttl,
}: ErrorType & { removable?: boolean; expended?: boolean }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [pause, setPause] = useState(false);
  const handleClose = () => {
    // console.log('handleClose', { timestamp });
    dispatch(systemActions.hideError({ timestamp }));
  };
  // console.log({ message });

  return (
    <div
      className={`px-5 py-3 border-2 rounded-md max-w-full md:w-1/2 mx-auto
        flex flex-col
        ${status >= 500 && 'border-red-500/80 bg-red-200/90'}
        ${status < 500 && status >= 400 && 'border-amber-500/80 bg-amber-200/90'}
        ${status < 400 && 'border-gray-500/80 bg-white/90'}
        `}
    >
      <div
        className='flex space-x-2 justify-between text-sm'
        onClick={() => setShow(!show)}
        onMouseEnter={() => setPause(true)}
        onMouseLeave={() => setPause(false)}
      >
        <div className='flex flex-wrap sm:flex-nowrap gap-2 items-center'>
          <div className='font-semibold text-red-800'>{status}</div>
          <div className='font-light  text-red-800'>{name}</div>
          <div className='font-light '>{message}</div>
        </div>
        {removable && (
          <TimerCloseButton
            timer={ttl}
            pause={pause}
            className='rounded-full p-.5 hover:text-red-600 text-lg font-semibold'
            onClick={handleClose}
          >
            <i className='icon-close' />
          </TimerCloseButton>
        )}
      </div>
      <div className='text-xs'>
        {validations?.map((i) => (
          <div key={i.property}>
            <strong className='mr-2'>{i.property}</strong>
            {i?.constraints?.matches}
          </div>
        ))}
      </div>
      {(expended || show) && (
        <div className='pt-2 text-xs font-mono'>
          <label className='font-semibold'>{t('Stack:')}</label>
          <pre className=' overflow-auto'>{stack}</pre>
          <div className='pt-2'>
            <strong>{method}</strong>:{path}
          </div>
        </div>
      )}
    </div>
  );
}
